<template>
  <div  :class="isSend==1 ? 'atalk' : 'btalk'">
    <img v-if="isSend==1" :src="user_avatar" class="avatar" />
    <img v-else :src="receive_avatar"  class="avatar"/>

    <!--消息类型，1文字消息，6申请查看简历，9发送红包，10同意查看简历，11拒绝查看简历，
      12邀请面试，13主动发送简历，16图片，
      17位置，18邀请入职，19签署合同，
      20同意面试，21拒绝面试，22同意入职，23拒绝入职，24同意签署，25拒绝签署
    -->
    <span v-if="type ==1" class="txt">{{ content }}</span>


    <div v-if="type==9" class="msginfo rich">
     
      <img 
        fit="cover"
        style="width: 70px; height: 70px"
        src="~@/assets/chat-img/hongbao.png"
        @click="redpackDetail"
       />
     
     
    </div>


    <div v-if="type == 16" class="msginfo image">
      <el-image 
        fit="cover"
        style="width: 40px; height: 40px"
        :src="value_field"
        :preview-src-list="[value_field]">
      </el-image>
    </div>

    <!--地理位置-->
    <div v-if="type==17" class="msginfo mianshi">
      <div>
        <img src="@/assets/chat-img/msg_location.png" alt="" />
        <b>{{value_field}}</b>
      </div>
      <p @click="locationInfo">点击查看</p>
    </div>


   
    <div v-if="type==12" class="msginfo mianshi">
      <div>
        <img src="@/assets/chat-img/mianshiyaoqing.png" alt="" />
        <!--<b v-if="isSend==1">面试邀请</b>
        <b v-if="isSend==2">面试邀请</b>-->
        <b>{{type_str}}</b>
      </div>
      <p @click="auditInfo">点击查看</p>
    </div>

    <div v-if="type==18" class="msginfo mianshi">
      <div>
        <img src="@/assets/chat-img/ruzhiyaoqing.png" alt="" />
        <!--<b v-if="isSend==1">入职邀请</b>
        <b v-if="isSend==2">入职邀请</b>-->
        <b>{{type_str}}</b>
      </div>
      <p @click="ruzhiInfo">点击查看</p>
    </div>

    <div v-if="type==19" class="msginfo mianshi">
      <div>
        <img src="@/assets/chat-img/qianshuhetong.png" alt="" />
        <!--<b v-if="isSend==1">签署合同</b>
        <b v-if="isSend==2">签署合同</b>-->
        <b>{{type_str}}</b>
      </div>
      <p @click="hetongInfo">点击查看</p>
    </div>


    <div v-if="type==20" class="msginfo mianshi">
      <div>
        <img src="@/assets/chat-img/qianshuhetong.png" alt="" />
        <b>{{type_str}}</b>
        <!--<b v-if="isSend==1">同意面试</b>
        <b v-if="isSend==2">同意面试</b>-->
      </div>
      <p @click="auditInfo">点击查看</p>
    </div>


    <div v-if="type==21" class="msginfo mianshi">
      <div>
        <img src="@/assets/chat-img/qianshuhetong.png" alt="" />
        <b>{{type_str}}</b>
         <!--<b v-if="isSend==1">拒绝面试</b>
        <b v-if="isSend==2">拒绝面试</b>-->
      </div>
      <p @click="auditInfo">点击查看</p>
    </div>


    <div v-if="type==22" class="msginfo mianshi">
      <div>
        <img src="@/assets/chat-img/ruzhiyaoqing.png" alt="" />
        <b>{{type_str}}</b>
        <!--<b v-if="isSend==1">同意入职</b>
        <b v-if="isSend==2">同意入职</b>-->
      </div>
      <p @click="ruzhiInfo">点击查看</p>
    </div>


    <div v-if="type==23" class="msginfo mianshi">
      <div>
        <img src="@/assets/chat-img/ruzhiyaoqing.png" alt="" />
        <b>{{type_str}}</b>
       <!-- <b v-if="isSend==1">拒绝入职</b>
        <b v-if="isSend==2">拒绝入职</b>-->
      </div>
      <p @click="ruzhiInfo">点击查看</p>
    </div>



    <div v-if="type==24" class="msginfo mianshi">
      <div>
        <img src="@/assets/chat-img/qianshuhetong.png" alt="" />
        <b>{{type_str}}</b>
        <!--
        <b v-if="isSend==1">同意签署</b>
        <b v-if="isSend==2">同意签署</b>-->
      </div>
      <p @click="hetongInfo">点击查看</p>
    </div>


    <div v-if="type==25" class="msginfo mianshi">
      <div>
        <img src="@/assets/chat-img/qianshuhetong.png" alt="" />
        <b>{{type_str}}</b>

        <!--
        <b v-if="isSend==1">拒绝签署</b>
        <b v-if="isSend==2">拒绝签署</b>-->
      </div>
      <p @click="hetongInfo">点击查看</p>
    </div>


    <div v-if="type==27" class="msginfo rich">
      <div>
        <img src="@/assets/chat-img/qianshuhetong.png" alt="" />

        <b>视频文件[{{ value_public }}]</b>
      </div>
      <p  @click="downloadFile"  style="cursor: pointer;">点击下载</p>
    </div>


    <div v-if="type==28" class="msginfo rich"  >
      <div>
        <img src="@/assets/chat-img/qianshuhetong.png" alt="" />
        <b>文件[{{ value_public }}]</b>
      </div>
      <p @click="downloadFile" style="cursor: pointer;">点击下载</p>
    </div>


    <!--<header v-else class="mianshi">
      <img src="@/assets/chat-img/infopdf.png" alt="" />
      <b>张大小发来附件</b>
    </header>-->

    <info-audit-dialog ref="refinfoAuditDialog"></info-audit-dialog>
    <info-ruzhi-dialog ref="refinfoRuzhiDialog" ></info-ruzhi-dialog>
    <info-contract-dialog ref="refinfoContractDialog" ></info-contract-dialog>
    <show-point-dialog ref="refLocationDialog" ></show-point-dialog>
    
  </div>
</template>

<script>
//import dafaultImg from '@/assets/chat-img/img1.png'
import { auditInfo,auditUpdate,addressInfo,addressUpdate,contractInfo,contractUpdate} from "@/api/chat/index";
import infoAuditDialog from "@/components/chat/info-audit-dialog.vue";
import infoRuzhiDialog from "@/components/chat/info-ruzhi-dialog.vue";
import infoContractDialog from "@/components/chat/info-contract-dialog.vue";

import showPointDialog from "@/components/map/show-point-dialog.vue";

export default {
  components: {
    infoAuditDialog,infoRuzhiDialog,infoContractDialog,showPointDialog
  },
  // props: ["img", "name", "time", "dialogue"],
  // ype 消息类型，1文字消息，6申请查看简历，9发送红包，10同意查看简历，11拒绝查看简历， 12邀请面试，13主动发送简历，16图片，17位置，18邀请入职，19签署合同-->
  props: {

    user_avatar:{
      type: String,
      default:''
    },
    receive_avatar:{
      type: String,
      default:''
    },

    isSend:{
      type: Number,
      default:1//1 发送
    },
    type:{
      type: Number,
      default:1//1   // ype 消息类型，1文字消息，6申请查看简历，9发送红包，10同意查看简历，11拒绝查看简历， 12邀请面试，13主动发送简历，16图片，17位置，18邀请入职，19签署合同-->
    },

    lat:{
      type: String,
      default:""//1   
    },

    lng:{
      type: String,
      default:""//1   
    },

    value_field:{
      type: String,
      default:""//1   
    },
    value_id:{
      type: String,
      default:""
    },

    content:{
      type: String,
      default:""
    },

    send_user_id:{
      type: String,
      default:''
    },

    receive_user_id:{
      type: String,
      default:''
    },

    type_str:{
      type: String,
      default:""
    },

    value_public:{
      type: String,
      default:""
    }

   
   
  },
  data () {
    return {
      //dafaultImg: dafaultImg
    }
  },

  methods:{

    auditInfo(){
      this.$refs.refinfoAuditDialog.init(this.isSend,this.value_id);
    },

    ruzhiInfo(){
      this.$refs.refinfoRuzhiDialog.init(this.isSend,this.value_id);      
    },

    hetongInfo(){
      this.$refs.refinfoContractDialog.init(this.isSend,this.value_id);
    },

    locationInfo(){
      this.$refs.refLocationDialog.init(this.lat,this.lng,this.value_field);
    },

    redpackDetail(){
      this.$message.warning("接口开发中");
    },

    downloadFile(){
      this.$message.warning("接口开发中");
    }

  }
};
</script>

<style lang="scss" scoped>
.btalk {
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
}
.atalk {
  display: flex;
  flex-direction: row-reverse;
  margin-bottom: 10px;
}


 .atalk  .avatar,
.btalk  .avatar {
  width: 35px;
  height: 35px;
  border-radius: 50%;
}


.atalk .avatar {
  margin-left: 10px;
}
 .btalk .avatar {
  margin-right: 10px;
}


.btalk .txt,
.atalk .txt {
  display: flex;
  font-size: 14px;
  line-height: 21px;
  color: #666666;
  padding: 11px 19px 10px 19px;
  background-color: #eef2ff;
  align-items: flex-start;
  justify-content: center;
  border-radius: 0px 6px 6px 6px;
  max-width: 400px;
}


 .atalk .txt {
  color: #ffffff;
  background-color: #4c71db;
  border-radius: 6px 0px 6px 6px;
}



.atalk  .image img,
 .btalk  .image img {
  width: 38px;
  height: 42px;
  margin-right: 10px;
}



 .btalk .msginfo,
 .atalk .msginfo {
  display: flex;
  font-size: 14px;
  // line-height: 21px;
  align-items: center;
  color: #666666;
  padding: 11px 19px 10px 19px;
  background: #ffffff;
  border-radius: 0px 6px 6px 6px;
}

.atalk .msginfo {
  color: #ffffff;
  background-color: #4c71db;
  border-radius: 6px 0px 6px 6px;
}

.atalk .msginfo.mianshi {
  color: #666666;
  display: block;
  border: 1px solid #707070;
  background-color: #ffffff;
  border-radius: 6px 0px 6px 6px;
  padding: 10px;
  font-size: 14px;

  div{
    display: flex;
    justify-content: space-between;
    justify-content: center;
    align-items: center;
    padding: 10px;
    img{
      width: 30px;
      margin-right: 10px;
    }

  }
  p{
    text-align: center;
    border-top: 1px solid #cecece;
    color: #4C71DB;
  }
}



.atalk .msginfo.rich {
  color: #666666;
  display: block;
  border: 1px solid #707070;
  background-color: #ffffff;
  border-radius: 6px 0px 6px 6px;
  padding: 10px;
  font-size: 14px;

  div{
    display: flex;
    justify-content: space-between;
    justify-content: center;
    align-items: center;
    padding: 10px;
    img{
      width: 30px;
      margin-right: 10px;
    }

  }
  p{
    text-align: center;
    border-top: 1px solid #cecece;
    color: #4C71DB;
  }
}




.btalk .msginfo {
  color: #ffffff;
  background-color: #4c71db;
  border-radius: 6px 0px 6px 6px;
}

.btalk .msginfo.mianshi {
  color: #666666;
  display: block;
  border: 1px solid #707070;
  background-color: #ffffff;
  border-radius: 6px 0px 6px 6px;
  padding: 10px;
  font-size: 14px;

  div{
    display: flex;
    justify-content: space-between;
    justify-content: center;
    align-items: center;
    padding: 10px;
    img{
      width: 30px;
      margin-right: 10px;
    }

  }
  p{
    text-align: center;
    border-top: 1px solid #cecece;
    color: #4C71DB;
  }
}



.btalk .msginfo.rich {
  color: #666666;
  display: block;
  border: 1px solid #707070;
  background-color: #ffffff;
  border-radius: 6px 0px 6px 6px;
  padding: 10px;
  font-size: 14px;

  div{
    display: flex;
    justify-content: space-between;
    justify-content: center;
    align-items: center;
    padding: 10px;
    img{
      width: 30px;
      margin-right: 10px;
    }

  }
  p{
    text-align: center;
    border-top: 1px solid #cecece;
    color: #4C71DB;
  }
}




</style>